export const ENABLE_CHECKOUT_EXPRESS_PAYPAL_FF =
    'checkout_enable_express_paypal';

export const POST_CHECKOUT_MANDATORY_QUESTIONS_ORGANIZATIONS_EXCLUSIONS_FF =
    'post-checkout-mandatory-questions-organizations-exclusions';

export const GROUP_WAIVER_QUESTIONS = 'checkout_group_waiver_questions';

export const ASK_REQUIRED_NON_WAIVER_QUESTIONS_AFTER_PAYMENT =
    'checkout_ask_required_non_waiver_questions_after_payment';
